import {Injectable, NgZone} from '../index';
import {EventEmitter, ObservableWrapper} from '../src/facade/async';
export class MockNgZone extends NgZone {
  private _mockOnStable: EventEmitter<any> = new EventEmitter(false);

  constructor() { super({enableLongStackTrace: false}); }

  get onStable() { return this._mockOnStable; }

  run(fn: Function): any { return fn(); }

  runOutsideAngular(fn: Function): any { return fn(); }

  simulateZoneExit(): void { ObservableWrapper.callNext(this.onStable, null); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
